import { createRouter, createWebHistory } from "vue-router";
import Login from "./views/Login.vue";
import UserManagement from "./views/UserManagement.vue";
import UserProfile from "./views/UserProfile.vue";
import MenuManagement from "./views/MenuManagement.vue";
import Calendar from "./views/Calendar.vue";
import Permission from "./views/Permission.vue";
import Log from "./views/Log.vue";
import Setting from "./views/Setting.vue";
import LogAPIExternal from "./views/LogAPIExternal.vue";
import GPTModelManagement from "./views/GPTModelManagement.vue";
import GPTModelDetail from "./views/GPTModelDetail.vue";
import FlowList from "./views/FlowList.vue";
import FlowCreator from "./views/Flow.vue";
import ToolManagement from "./views/ToolManagement.vue";
import Setup from "./views/Setup.vue";
import GPTModelNodeManagement from "./views/GPTModelNodeManagement.vue";
import GPTModelNodeDetail from "./views/GPTModelNodeDetail.vue";
import GroupReplacetext from "./views/GroupReplacetext.vue";
import ReplaceText from "./views/ReplaceText.vue";
import UploadCSV from "./views/UploadCSV.vue";
import UploadVector from "./views/UploadVector.vue";
import UploadVectorEdit from "./views/UploadVectorEdit.vue";
import UploadSoundToDocument from "./views/UploadSoundToDocument.vue";
import UploadSoundToDocumentDetail from "./views/UploadSoundToDocumentDetail.vue";
import DataIntegration from "./views/DataIntegration.vue";
import DataIntegrationDetail from "./views/DataIntegrationDetail.vue";
import ModelAndVectorManagement from "./views/ModelAndVectorManagement.vue";
import Dashboard from "./views/Dashboard.vue";
import ValidationGenerate from "./views/ValidationGenerate.vue";
import ValidationGenerateUpload from "./views/ValidationGenerateUpload.vue";
import ValidationProcess from "./views/ValidationProcess.vue";
import ValidationPositive from "./views/ValidationPositive.vue";
import ValidationNegative from "./views/ValidationNegative.vue";
import ValidationPositiveDetail from "./views/ValidationPositiveDetail.vue";
import ValidationNegativeDetail from "./views/ValidationNegativeDetail.vue";

import LogMessage from "./views/LogMessage.vue";
import LogEvent from "./views/LogEvent.vue";
import Stream from "./views/Stream.vue";
import GroupPromptTemplate from "./views/GroupPromptTemplate.vue";
import FullStreamReDesign from "./views/FullStreamReDesign.vue";
import DashboardScore from "./views/DashboardScore.vue";
import SetupSocial from "./views/SetupSocial.vue";
import SetupGroupModel from "./views/SetupGroupModel.vue";
import UserChatManagement from "./views/UserChatManagement.vue";
import ChatService from "./views/ChatService.vue";

import Cookies from 'js-cookie';
import ModelData from './views/ModelData.vue';
import AccessDenied from './views/AccessDenied.vue';
import ErrorPage from './views/ErrorPage.vue';


import ModelQuickGroup from './views/ModelQuickGroup.vue';
import ModelQuickReply from './views/ModelQuickReply.vue';
import SettingExternalConnector from './views/SettingExternalConnector.vue'
import PlayGround from './views/PlayGround.vue';
import ServiceTheme from './views/ConfigTheme.vue';
import ConsentConfig from './views/ConsentConfig.vue';

//Report
import ReportQuestionTop10 from './views/ReportQuestionTop10.vue';
import ReportUserTop10 from './views/ReportUserTop10.vue';
import ReportUserUse from './views/ReportUserUse.vue';
import ReportFeedback from './views/ReportFeedback.vue';

import PromptTemplate from './views/PromptTemplate.vue';
import Release from './views/Release-notes.vue';
import IntentGroup from './views/IntentGroup.vue';
import IntentSession from './views/IntentSession.vue';
import IntentSessionDetail from './views/IntentSessionDetail.vue';

import LoginSnippet from "./views/Snippet/LoginSnippet.vue";
import Snippet from "./views/Snippet/Snippet.vue";
import RedirectFromLogin from "./views/RedirectFromLogin.vue";
import ReportTokenSum from "./views/ReportTokenSum.vue";
import GroupUserManagement from "./views/GroupUserManagement.vue";
import UserGroupDetail from "./views/UserGroupDetail.vue";
import SetupUserGroup from "./views/SetupUserGroup.vue";
import BlacklistChatUserManagement from "./views/BlacklistChatUserManagement.vue";
import FileManagements from "./views/FileManagement.vue";
import ShortcutMenu from "./views/ShortcutMenu.vue";
import ProductGroup from "./views/ProductGroup.vue";
import ProductDetail from "./views/ProductDetail.vue";
import GraphManager from "./views/GraphManager.vue";
import GraphEditor from "./views/GraphEditor.vue";
import KnowledgeGraphMarkdownEditor from "./views/KnowledgeGraphMarkdownEditor.vue"; // S16-P1 — wizard แปลงเอกสารเป็น Knowledge Graph

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL), // ใช้ createWebHistory แทน mode: "history"
  base: import.meta.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: {
        name: "Login",
      },
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/RedirectFromLogin",
      name: "RedirectFromLogin",
      component: RedirectFromLogin,
    },
    {
      path: "/LoginSnippet",
      name: "LoginSnippet",
      component: LoginSnippet,
    },
    {
      path: "/Snippet",
      name: "Snippet",
      component: Snippet,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/Usermanagement",
      name: "UserManagement",
      component: UserManagement,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/KnowledgeGraphs",
      name: "KnowledgeGraphs",
      component: GraphManager,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      // graphKey เป็น id ที่ผู้ใช้เห็นและ import ใช้ จึงวางไว้บน URL ให้แชร์ลิงก์ได้
      path: "/KnowledgeGraphs/:graphKey",
      name: "KnowledgeGraphDetail",
      component: GraphEditor,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      // ลิงก์เก่า /graphrag ที่ผู้ใช้ bookmark ไว้ก่อน S10-P1 — คงไว้ไม่ให้พัง
      path: "/graphrag",
      redirect: { name: "KnowledgeGraphs" },
    },
    {
      path: "/graphrag/:graphKey",
      redirect: (to) => ({ name: "KnowledgeGraphDetail", params: to.params }),
    },
    {
      path: "/userprofile",
      name: "UserProfile",
      component: UserProfile,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/menumanagement",
      name: "MenuManagement",
      component: MenuManagement,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/calendar",
      name: "Calendar",
      component: Calendar,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/permission",
      name: "Permission",
      component: Permission,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/log",
      name: "Log",
      component: Log,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/setting",
      name: "Setting",
      component: Setting,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    // {
    //   path: "/usergroup",
    //   name: "UserGroup",
    //   component: UserGroup,
    //   meta: {
    //     requiresAuth: true,
    //   },
    // },
    {
      path: "/GroupReplacetext",
      name: "GroupReplacetext",
      component: GroupReplacetext,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/ReplaceText",
      name: "ReplaceText",
      component: ReplaceText,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/FlowList",
      name: "FlowList",
      component: FlowList,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/FlowCreator",
      name: "FlowCreator",
      component: FlowCreator,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/ToolManagement",
      name: "ToolManagement",
      component: ToolManagement,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/GroupPromptTemplate",
      name: "GroupPromptTemplate",
      component: GroupPromptTemplate,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/GPTModelManagement",
      name: "GPTModelManagement",
      component: GPTModelManagement,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/GPTModelDetail",
      name: "GPTModelDetail",
      component: GPTModelDetail,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/GPTModelInternal",
      name: "GPTModelNodeManagement",
      component: GPTModelNodeManagement,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/GPTModelInternalDetail",
      name: "GPTModelInternalDetail",
      component: GPTModelNodeDetail,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/VectorManagement",
      name: "VectorManagement",
      component: UploadCSV,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      // S16-P1 — wizard แปลงเอกสาร (Document List) เป็น Knowledge Graph · meta เท่ากับ /VectorManagement (มติ S10-P1 D10)
      path: "/KnowledgeGraphMarkdownEditor",
      name: "KnowledgeGraphMarkdownEditor",
      component: KnowledgeGraphMarkdownEditor,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/UploadVector",
      name: "UploadVector",
      component: UploadVector,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/UploadVectorEdit",
      name: "UploadVectorEdit",
      component: UploadVectorEdit,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/DataIntegration",
      name: "DataIntegration",
      component: DataIntegration,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    
    {
      path: "/DataIntegrationDetail",
      name: "DataIntegrationDetail",
      component: DataIntegrationDetail,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/ProductGroup",
      name: "ProductGroup",
      component: ProductGroup,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/ProductDetail",
      name: "ProductDetail",
      component: ProductDetail,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/IntentGroup",
      name: "IntentGroup",
      component: IntentGroup,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    
    {
      path: "/IntentSession",
      name: "IntentSession",
      component: IntentSession,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/IntentSessionDetail",
      name: "IntentSessionDetail",
      component: IntentSessionDetail,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },

    {
      path: "/ModelAndVectorManagement",
      name: "ModelAndVectorManagement",
      component: ModelAndVectorManagement,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/DashboardScore",
      name: "DashboardScore",
      component: DashboardScore,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/ValidationGenerate",
      name: "ValidationGenerate",
      component: ValidationGenerate,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/ValidationGenerateUpload",
      name: "ValidationGenerateUpload",
      component: ValidationGenerateUpload,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/ValidationProcess",
      name: "ValidationProcess",
      component: ValidationProcess,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/ValidationPositive",
      name: "ValidationPositive",
      component: ValidationPositive,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/ValidationNegative",
      name: "ValidationNegative",
      component: ValidationNegative,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/ValidationPositiveDetail",
      name: "ValidationPositiveDetail",
      component: ValidationPositiveDetail,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/ValidationNegativeDetail",
      name: "ValidationNegativeDetail",
      component: ValidationNegativeDetail,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/LogMessage",
      name: "LogMessage",
      component: LogMessage,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/Stream",
      name: "Stream",
      component: Stream,
      meta: {
        requiresAuth: true,
        isProductAdmin: true,
      },
    },
    // {
    //   path: "/FullStream",
    //   name: "FullStream",
    //   component: FullStream,
    //   meta: {
    //     requiresAuth: false,
    //   },
    // },
    {
      path: "/FullStream",
      name: "FullStream",
      component: FullStreamReDesign,
      meta: {
        requiresAuth: false,
        isProductAdmin: true,
      },
    },
    {
      path: "/setup",
      name: "Setup",
      component: Setup,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: false,
      },
    },
    {
      path: "/SetupSocial",
      name: "SetupSocial",
      component: SetupSocial,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/SetupGroupModel",
      name: "SetupGroupModel",
      component: SetupGroupModel,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/modeldata",
      name: "ModelData",
      component: ModelData,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: false,
      },
    },  
    // {
    //   path: "/ModelQuick",
    //   name: "ModelQuick",
    //   component: ModelQuick,
    // },

    {
      path: "/ModelShortcut",
      name: "ModelShortcut",
      component: ModelQuickGroup,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/ModelQuickReply",
      name: "ModelQuickReply",
      component: ModelQuickReply,
      meta: {
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      },
    },
    {
      path: "/SettingExternalConnector",
      name: "SettingExternalConnector",
      component: SettingExternalConnector,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      }
    },
    {
      path: "/Playground",
      name: "Playground",
      component: PlayGround,
      meta:{
        requiresAuth: true,
        isProductAdmin: true,
      }
    },
    {
      path: "/ServiceTheme",
      name: "ServiceTheme",
      component: ServiceTheme,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      }
    },
    {
      path: "/AccessDenied",
      name: "AccessDenied",
      component: AccessDenied,
    },
    {
      path: "/UserChatManagement",
      name: "UserChatManagement",
      component: UserChatManagement,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      }
    },
    {
      path: "/ChatService",
      name: "ChatService",
      component: ChatService,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      }
    },
    
    {
      path: "/ReportQuestionTop10",
      name: "ReportQuestionTop10",
      component: ReportQuestionTop10,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      }
    },
    {
      path: "/ReportUserTop10",
      name: "ReportUserTop10",
      component: ReportUserTop10,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      }
    },
    {
      path: "/ReportUserUse",
      name: "ReportUserUse",
      component: ReportUserUse,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      }
    },
    {
      path: "/PromptTemplate",
      name: "PromptTemplate",
      component: PromptTemplate,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      }
    },
    {
      path: "/Release-notes",
      name: "Release-notes",
      component: Release,
      meta:{
        requiresAuth: true,
        // isAdmin: true,
        isProductAdmin: true,
      }
    },
    {
      path: "/ReportTokenSum",
      name: "ReportTokenSum",
      component: ReportTokenSum,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      }
    },

    {
      path:"/LogEvent",
      name:"LogEvent",
      component: LogEvent,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: false,
      }
    },
    {
      path:"/LogAPIExternal",
      name:"LogAPIExternal",
      component: LogAPIExternal,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: false,
      }
    },
    {
      path: "/GroupUserManagement",
      name: "GroupUserManagement",
      component: GroupUserManagement,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      }
    },
    {
      path: "/UserGroupDetail",
      name: "UserGroupDetail",
      component: UserGroupDetail,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      }
    },
    {
      path: "/SetupUserGroup",
      name: "SetupUserGroup",
      component: SetupUserGroup,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      }
    },
    {
      path: "/UploadSoundToDocument",
      name: "UploadSoundToDocument",
      component: UploadSoundToDocument,
      meta:{
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: true,
      }
    },
    {
      path: "/UploadSoundToDocumentDetail",
      name: "UploadSoundToDocumentDetail",
      component: UploadSoundToDocumentDetail,
      meta:{
        requiresAuth: true,
        isAdmin: false,
        isProductAdmin: true,
      }
    },
    {
      path: "/BlacklistChatUserManagement",
      name: "BlacklistChatUserManagement",
      component: BlacklistChatUserManagement,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      }
    },
    {
      path: "/ReportFeedback",
      name: "ReportFeedback",
      component: ReportFeedback,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      }
    },
    {
      path: "/ConsentConfig",
      name: "ConsentConfig",
      component: ConsentConfig,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: false, 
      }
    },
    {
      path: '/error/:code',
      name: 'error',
      component: ErrorPage,
      meta: {
        requiresAuth: false,
        isProductAdmin: true,
      },
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/error/404'
    },
    {
      path: "/FileManagements",
      name: "FileManagements",
      component: FileManagements,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      }
    },
    {
      path: "/ShortcutMenu",
      name: "ShortcutMenu",
      component: ShortcutMenu,
      meta:{
        requiresAuth: true,
        isAdmin: true,
        isProductAdmin: true,
      }
    },
  ],
});
const routeRequiresAuth = (route) => route.matched.some((record) => record.meta.requiresAuth);
const routeRequiresAdmin = (route) => route.matched.some((record) => record.meta.isAdmin);
const isProductAdminRouteAllowed = (route) => import.meta.env.VITE_APP_ProductAdmin == true ? route.matched.some((record) => record.meta.isProductAdmin) : true; //NOSONAR
const hasAdminRole = (roleId) => roleId == 0 || roleId == 1 || roleId == 6;
const canAccessAdminRoute = (route) => isProductAdminRouteAllowed(route) && hasAdminRole(Cookies.get('roleId'));

router.beforeEach((to, from, next) => {
  if (!routeRequiresAuth(to)) {
    next();
    return;
  }

  if (!Cookies.get('authenticated')) {
    next("/login");
    return;
  }

  if (routeRequiresAdmin(to) && !canAccessAdminRoute(to)) {
    next({ name: 'AccessDenied'});
    return;
  }

  next();
  // next()
});

export default router;
